import { isArray } from "lodash-es";
import { CompetitionFilterTypes } from "~pages/Competitions/CompetitionsListPage/enums/competitionFilterTypes.ts";
import type { CompetitionTransformed } from "~pages/Competitions/types/competitionTransformed.ts";

export const filterCompetitions = (
  allCompetitions: CompetitionTransformed[],
  currentFilter: Record<string, any>,
  search: string,
): CompetitionTransformed[] => {
  let data = allCompetitions || [];

  Object.keys(currentFilter).forEach((filterKey: string) => {
    const filterType = CompetitionFilterTypes[filterKey as keyof typeof CompetitionFilterTypes];
    if (!currentFilter[filterKey] || (isArray(currentFilter[filterKey]) && !currentFilter[filterKey].length)) return;

    const currentFilterValues = isArray(currentFilter[filterKey]) ? currentFilter[filterKey].map((x) => x.value) : currentFilter[filterKey];

    if (filterType === CompetitionFilterTypes.AgeGroup) {
      data = data.filter((x) => currentFilterValues.includes(x.ageGroup));
    }

    if (filterType === CompetitionFilterTypes.League) {
      data = data.filter((x) => currentFilterValues.includes(x.league?.leagueId));
    }
  });

  if (search) {
    data = data.filter(
      ({ nameLocal, abbreviationLocal }) =>
        nameLocal?.toLowerCase().includes(search.toLowerCase()) || abbreviationLocal?.toLowerCase().includes(search.toLowerCase()),
    );
  }

  return data;
};
